// src/components/blogs/RecentPosts.jsx

import React from "react";
import { motion } from "framer-motion";

const posts = [
  {
    title: "How to Train for Colorado 14ers",
    link: "/blog/colorado-14ers",
    image: require("../../assets/blogs/colorado_14ers/b1.jpg"),
  },
  {
    title: "How to Build a Model Physique Without Bulking",
    link: "/blog/model-physique-without-bulking",
    image: require("../../assets/blogs/model_physique_without_bulking/b1.jpg"),
  },
  {
    title: "Nutrition for Busy Professionals",
    link: "/blog/nutrition-for-professionals",
    image: require("../../assets/blogs/nutrition_for_busy_professionals/b1.jpg"),
  },
];

export default function RecentPosts() {
  return (
    <div className="bg-black/40 border border-gray-700 rounded-xl p-6 shadow-2xl flex flex-col gap-6">
      
      <h3 className="text-gray-100 text-2xl font-bold tracking-widest text-center uppercase mb-4">
        Recent Posts
      </h3>

      <div className="flex flex-col gap-5">
        {posts.map((post, idx) => (
          <motion.a
            key={idx}
            href={post.link}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 160 }}
            className="relative w-full h-[260px] rounded-xl overflow-hidden shadow-lg group"
          >
            {/* Image with uniform height and smooth hover effect */}
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover transition duration-300 group-hover:scale-105 group-hover:brightness-110"
            />

            {/* Gradient overlay for title readability */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent py-3 px-4 flex items-center justify-center">
              <p className="text-white text-sm md:text-base font-semibold text-center">
                {post.title}
              </p>
            </div>
          </motion.a>
        ))}
      </div>

    </div>
  );
}
